/**
 * How a Vicidial server's Asterisk state is described, in one place.
 *
 * The client-facing servers list shows this read-only; the client profile in
 * super admin shows it next to the Apply button that changes it. Applying is
 * deliberately only in the profile: it writes /etc/asterisk and reloads the
 * switchboard, which is not a client-portal action.
 */
import { Badge } from '@/components/ui';

export const ASTERISK_STATE_TONES: Record<string, 'green' | 'amber' | 'red' | 'gray'> = {
  APPLIED: 'green',
  PENDING: 'amber',
  STALE: 'amber',
  FAILED: 'red',
  NOT_CONFIGURED: 'gray',
};

export const ASTERISK_STATE_LABELS: Record<string, string> = {
  APPLIED: 'Live on Asterisk',
  PENDING: 'Ready to apply',
  STALE: 'Changed since applied',
  FAILED: 'Apply failed',
  NOT_CONFIGURED: 'Not configured',
};

export const ASTERISK_STATE_HELP: Record<string, string> = {
  APPLIED: 'The trunk and dialplan for this server are on the switchboard.',
  PENDING: 'The configuration is generated but has not been applied yet.',
  STALE: 'Settings changed after this was applied. Apply again to catch Asterisk up.',
  FAILED: 'The last apply did not succeed. The previous configuration was restored.',
  NOT_CONFIGURED: 'Add the SIP host to generate this server’s Asterisk configuration.',
};

export function AsteriskStateBadge({ state }: { state: string }) {
  return (
    <Badge tone={ASTERISK_STATE_TONES[state] ?? 'gray'}>
      {ASTERISK_STATE_LABELS[state] ?? state}
    </Badge>
  );
}
